import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const OrderGuidesListCollectionsDocument = gql`
  query OrderGuidesListCollections(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    getSalesPortalOrderGuideCollections(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      collections {
        is_default
        name
        sort_order
        type
        uuid
      }
    }
    order_guide_restaurant_collection(
      where: {
        restaurant_uuid: { _eq: $restaurantUUID }
        supplier_uuid: { _eq: $supplierUUID }
      }
    ) {
      linked_order_guide_supplier_collection_uuid
      order_guide_restaurant_partitions {
        uuid
      }
      uuid
    }
    order_guide_supplier_collection(
      where: {
        restaurant_uuid: { _eq: $restaurantUUID }
        supplier_uuid: { _eq: $supplierUUID }
      }
    ) {
      order_guide_supplier_partitions {
        uuid
      }
      uuid
    }
    chats(
      where: {
        restaurant_uuid: { _eq: $restaurantUUID }
        supplier_uuid: { _eq: $supplierUUID }
      }
    ) {
      custom_order_guide_editing_enabled
      order_guide_merge_strategy
      uuid
      supplier {
        supplier_metadata {
          order_guide_merge_strategy
          uuid
        }
        uuid
      }
    }
  }
`;
export function useOrderGuidesListCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.OrderGuidesListCollectionsQuery,
    Types.OrderGuidesListCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.OrderGuidesListCollectionsQuery,
    Types.OrderGuidesListCollectionsQueryVariables
  >(OrderGuidesListCollectionsDocument, options);
}
export function useOrderGuidesListCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OrderGuidesListCollectionsQuery,
    Types.OrderGuidesListCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.OrderGuidesListCollectionsQuery,
    Types.OrderGuidesListCollectionsQueryVariables
  >(OrderGuidesListCollectionsDocument, options);
}
export type OrderGuidesListCollectionsQueryHookResult = ReturnType<
  typeof useOrderGuidesListCollectionsQuery
>;
export type OrderGuidesListCollectionsLazyQueryHookResult = ReturnType<
  typeof useOrderGuidesListCollectionsLazyQuery
>;
export type OrderGuidesListCollectionsQueryResult = Apollo.QueryResult<
  Types.OrderGuidesListCollectionsQuery,
  Types.OrderGuidesListCollectionsQueryVariables
>;

/**
 * Wrapped version of useGeneratedOrderGuidesListCollectionsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedOrderGuidesListCollectionsQuery(
  options?: Apollo.QueryHookOptions<
    Types.OrderGuidesListCollectionsQuery,
    Types.OrderGuidesListCollectionsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.OrderGuidesListCollectionsQuery,
    Types.OrderGuidesListCollectionsQueryVariables
  >(OrderGuidesListCollectionsDocument, options);
}

/**
 * Wrapped version of useGeneratedOrderGuidesListCollectionsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedOrderGuidesListCollectionsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.OrderGuidesListCollectionsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.OrderGuidesListCollectionsQuery,
    Types.OrderGuidesListCollectionsQueryVariables
  >(OrderGuidesListCollectionsDocument, lazyOptions);
}
